(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mav3d-fertigung"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var steps = root.querySelectorAll('.mav3d-fs__step');
      var imgs = root.querySelectorAll('.mav3d-fs__img');
      var ticks = root.querySelectorAll('.mav3d-fs__tick');
      if (!steps.length || !('IntersectionObserver' in window)) return;

      var aktiv = -1;
      function zeige(i) {
        if (i === aktiv) return;
        aktiv = i;
        [steps, imgs, ticks].forEach(function (liste) {
          Array.prototype.forEach.call(liste, function (el) {
            el.classList.toggle('is-active', Number(el.dataset.step) === i);
          });
        });
      }

      var beobachter = new IntersectionObserver(function (eintraege) {
        var beste = null;
        eintraege.forEach(function (e) {
          if (e.isIntersecting && (!beste || e.intersectionRatio > beste.intersectionRatio)) beste = e;
        });
        if (beste) zeige(Number(beste.target.dataset.step));
      }, { rootMargin: '-40% 0px -40% 0px', threshold: [0, 0.25, 0.5, 1] });

      Array.prototype.forEach.call(steps, function (s) { beobachter.observe(s); });
    }

    function init() {
      document.querySelectorAll('[data-mav3d-fertigung]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
